import React, { useEffect } from 'react';
import aboutImage from '../assets/images/about.jpg';
import AOS from 'aos';
import 'aos/dist/aos.css';

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section id="about" className="py-5 bg-white">
      <div className="container">
        <div className="row align-items-center">
          {/* Image */}
          <div className="col-md-6 mb-4 mb-md-0" data-aos="fade-right">
            <img src={aboutImage} alt="About Us" className="img-fluid rounded shadow" />
          </div>

          {/* Text */}
          <div className="col-md-6" data-aos="fade-left">
            <h2>About Our Powder Coating</h2>
            <p className="lead">We are specialists in high-performance powder coating solutions, offering vibrant colors, corrosion resistance, and industrial-grade durability.</p>
            <p>
              With over a decade of experience, our team has worked with a range of industries including automotive, construction, and manufacturing. We take pride in our attention to detail, fast turnaround times, and commitment to customer satisfaction.
            </p>
            <ul className="list-unstyled mt-3">
              <li>✅ Advanced powder coating technology</li>
              <li>✅ Eco-friendly processes</li>
              <li>✅ Custom batch sizes & finishes</li>
              <li>✅ Pan India delivery available</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
